import type { TOC } from '@ember/component/template-only';

import bgUrl from '../../../assets/images/quick-start-guide-hero.jpg?url';

interface QuickStartGuideHeroSignature {
  Args: {
    title?: string;
    intro?: string;
  };
  Element: HTMLElement;
}

const QuickStartGuideHero: TOC<QuickStartGuideHeroSignature> = <template>
  <section
    class="coaching-quick-start-hero mx-n3 mx-lg-n4"
    aria-labelledby="quick-start-guide-hero-heading"
    ...attributes
  >
    <div
      class="coaching-quick-start-hero-media overflow-hidden"
      aria-hidden="true"
    >
      <img
        src={{bgUrl}}
        alt=""
        class="coaching-quick-start-hero-image w-100 h-100 object-fit-cover"
      />
    </div>

    <div class="card border shadow-sm coaching-quick-start-hero-card rounded-4">
      <div class="card-body p-4 p-lg-5">
        <h1 class="h3 fw-bold mb-3" id="quick-start-guide-hero-heading">
          {{if @title @title "Quick start guide"}}
        </h1>
        <p class="text-body-secondary mb-0">
          {{if
            @intro
            @intro
            "Everything you need to know before your first session: how coaching
              works, choosing your coach, and program rules."
          }}
        </p>
      </div>
    </div>
  </section>
</template>;

export default QuickStartGuideHero;
